<script>
import PageWrapper from '@components/support/PageWrapper';
import PageMixin from '@/mixins/page';
import axios from 'axios';

export default {
  components: { PageWrapper },
  mixins: [ PageMixin ],
  props: {
    signupRequestID: {
      type: String,
      required: true
    }
  },

  created () {
    axios.post(this.$cove.getAPI({ name: 'api.signuprequests', params: { id: this.signupRequestID } }))
      .then((response) => {
        window.location.href = response.data;
      });
  }
};
</script>